export const blogs = {
  GET_BLOGS: "GET_BLOGS",
  GET_BLOG: "GET_BLOG",
  ADD_BLOG: "ADD_BLOG",
  DELETE_BLOG: "DELETE_BLOG",
};
